import { AccountStatus } from 'components/users/users.enums';

export interface SuccessResponse {
  success: boolean;
  message?: string;
}

export interface SignUpDto {
  email: string;
  password: string;
  inviteToken: string;
}

export interface SignInDto {
  email?: string;
  password?: string;
  refreshToken?: string;
}

export interface SessionInfoDto {
  accessToken: string;
  refreshToken: string;
  isInvitationSend: boolean;
  accountStatus: AccountStatus | null;
}

export interface SendUpdateEmailVerificationCodeRequestDto {
  email: string;
  accountPasswordValidationToken: string;
}

export interface UpdatePasswordRequestDto {
  oldPassword: string;
  newPassword: string;
}

export interface AccountDto {
  id: number;
  intermediaryId: string;
  email: string;
  accountStatus: AccountStatus | null;
  phone: string;
  isInvitationSend: boolean;
  firstName: string;
  lastName: string;
  permissions: string[];
  mdaSignedPermissions: string[] | null;
  roles: string[];
  position: string;
  isMainContact: boolean;
}

export enum UpdatePasswordErrorMessage {
  InvalidPassword = 'Invalid Password',
  InternalError = 'Internal Error',
}

export interface UpdatePasswordResponse extends SuccessResponse {
  message?: UpdatePasswordErrorMessage;
}

export interface VerifyPasswordResponse extends SuccessResponse {
  accountPasswordValidationToken?: string;
  message?: UpdatePasswordErrorMessage;
}

export interface InvitedUser {
  accountExist: boolean;
  email?: string;
}

export interface UpdatePersonalInformationResponse {
  firstName: string;
  lastName: string;
  phone: string | null;
  position: string | null;
}
